/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState, useContext } from 'react';
import { Box, TextField, FormControl, FormControlLabel, Checkbox,MenuItem , Button, Select , Container as MaterialContainer, Input } from '@mui/material';
import AlertDialog from 'components/AlertDialog';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useDeleteUser, useUpdateUser } from 'services/UserService';
import LoaderContext from 'contexts/LoaderContext';
import { useParams, useNavigate } from "react-router-dom";
import { CpfMaskInput, PhoneMaskInput } from 'components/TextMaskCustom';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import { InputLabel, Typography } from '../../node_modules/@mui/material/index';

const { REACT_APP_BASE_URL } = process.env;

export const api = axios.create({
    baseURL: REACT_APP_BASE_URL,
});

export default function UserDetail({ value, index, user }) {
    const { updateIsLoadingStatus } = useContext(LoaderContext);
    const navigate = useNavigate();

    const [userData, setUserData] = useState(user);
    const [alertModalOpen, setAlertModalOpen] = useState(false);
    const [snackAlert, setSnackAlert] = useState({
        open: false,
        message: '',
        level: 'success'
    });
    const [isGeneratingReport, setIsGeneratingReport] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1); 
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const handleChange = (key, value) => {
        setUserData({ ...userData, [key]: value });
    };

    const handleExtractReport = async () => {
        try { 
            setIsGeneratingReport(true);

            const userId = userData?.id || user?.id;

            const response = await api.get(`/usage-report/${userId}`, {
                params: { year: selectedYear, month: selectedMonth },
                timeout: 300000 
            });
        
            const data = response.data;
            const htmlUrl = `${api.defaults.baseURL}/usage-report/temp/${data.fileName}`;
            window.open(htmlUrl, '_blank');
        
        } catch (error) {
            console.error('Erro:', error);
            setSnackAlert({
                open: true,
                message: 'Erro ao gerar relatório.',
                level: 'error'
            });
        } finally { 
            setIsGeneratingReport(false);
        }
    };

    const {
        data: useUpdateUserData,
        loading: useUpdateUserLoading,
        status: useUpdateUserStatus,
        request: useUpdateUserRequest,
        source: useUpdateUserSource,
    } = useUpdateUser(userData.id, userData);

    const {
        data: useDeleteUserData,
        loading: useDeleteUserLoading,
        status: useDeleteUserStatus,
        request: useDeleteUserRequest,
        source: useDeleteUserSource,
    } = useDeleteUser(userData.id);

    useEffect(() => {
        setUserData(user);
    }, [user])

    useEffect(() => {
        if (!useDeleteUserStatus) return;
        if (useDeleteUserStatus === 200 || useDeleteUserStatus === 204) {
            setSnackAlert({
                open: true,
                message: 'Usuário removida com sucesso!',
                level: 'success'
            });
            return navigate(-1)
        }

        setSnackAlert({
            open: true,
            message: 'Falha ao remover a usuário!',
            level: 'error'
        })
    }, [useDeleteUserStatus]);

    useEffect(() => {
        if (!useUpdateUserStatus) return;
        if (useUpdateUserStatus === 200 || useUpdateUserStatus === 204) {
            return setSnackAlert({
                open: true,
                message: 'Usuário atualizada com sucesso!',
                level: 'success'
            });
        }

        setSnackAlert({
            open: true,
            message: 'Falha ao atualizar a usuário!',
            level: 'error'
        })
    }, [useUpdateUserStatus]);

    useEffect(() => {
        updateIsLoadingStatus(useUpdateUserLoading || useDeleteUserLoading)
    }, [useUpdateUserLoading, useDeleteUserLoading])

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ pt: 3 }}>
                    <AlertDialog
                        isOpen={alertModalOpen}
                        setIsOpen={setAlertModalOpen}
                        onConfirm={() => useDeleteUserRequest()}
                        message={`Tem certeza que deseja apagar este usuário?\nTodos as informações relacionadas serão removidas e os dados não poderão ser recuperados.`}
                    />
                    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                        open={snackAlert.open} autoHideDuration={3000} onClose={() => setSnackAlert({ ...snackAlert, open: false })}>
                        <MuiAlert variant="filled" onClose={() => setSnackAlert({ ...snackAlert, open: false })} severity={snackAlert.level} sx={{ width: '100%' }}>
                            {snackAlert.message || ''}
                        </MuiAlert>
                    </Snackbar>
                    <Box sx={{ 
                        pt: 3,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'start'
                    }} >
                        <FormControl fullWidth sx={{ maxWidth: '400px' }}>
                            <TextField
                                label="Nome"
                                color="secondary"
                                margin="normal"
                                focused
                                value={userData?.name}
                                fullWidth
                                onChange={(e) => handleChange('name', e?.target?.value || '')}
                            />
                            <TextField
                                label="E-mail"
                                color="secondary"
                                margin="normal"
                                focused
                                value={userData?.email}
                                fullWidth
                                onChange={(e) => handleChange('email', e?.target?.value || '')}
                            />
                            <TextField
                                label="Telefone"
                                color="secondary"
                                margin="normal"
                                focused
                                value={userData?.phone}
                                fullWidth
                                onChange={(e) => handleChange('phone', e?.target?.value || '')}
                                InputProps={{
                                    inputComponent: PhoneMaskInput
                                }}
                            />
                            <TextField
                                label="CPF"
                                color="secondary"
                                margin="normal"
                                focused
                                value={userData?.cpf}
                                fullWidth
                                onChange={(e) => handleChange('cpf', e?.target?.value || '')}
                                InputProps={{
                                    inputComponent: CpfMaskInput
                                }}
                            />
                            <FormControlLabel
                                control={<Checkbox
                                    onChange={e => handleChange('isAdmin', e?.target?.checked)}
                                    checked={!!userData.isAdmin} />}
                                label="Admin"
                            />

                            <FormControlLabel
                                control={<Checkbox
                                    onChange={e => handleChange('isSubscriber', e?.target?.checked)}
                                    checked={!!userData.isSubscriber} />}
                                label="Assinante"
                            />
                            
                            <FormControl fullWidth>
                                <Button
                                    variant="contained"
                                    disableElevation style={{ fontWeight: 'bolder' }}
                                    sx={{ marginTop: '40px' }}
                                    onClick={() => useUpdateUserRequest(userData)}
                                >
                                    SALVAR
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    disableElevation style={{ fontWeight: 'bolder' }}
                                    sx={{ marginTop: '10px' }}
                                    onClick={() => setAlertModalOpen(true)}
                                >
                                    REMOVER
                                </Button>
                            </FormControl>

                        </FormControl>
                        <Box display="flex" flexDirection="column" alignItems="flex-start" gap={2}>
                            <Typography variant="h3">Relatório</Typography>
                            <FormControl fullWidth>
                                <InputLabel id="month-label">Mês</InputLabel>
                                <Select
                                    labelId="month-label"
                                    value={selectedMonth}
                                    label="Mês"
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                >
                                {[
                                    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                                    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
                                ].map((monthName, index) => (
                                    <MenuItem key={index + 1} value={index + 1}>
                                        {monthName}
                                    </MenuItem>
                                ))}
                                </Select>
                            </FormControl>

                            <TextField
                                label="Ano"
                                type="number"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(Number(e.target.value))}
                                fullWidth
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                disableElevation 
                                sx={{ fontWeight: 'bolder', mt: 1 }}
                                onClick={handleExtractReport}
                                disabled={isGeneratingReport}
                                startIcon={isGeneratingReport ? <CircularProgress size={20} color="inherit" /> : null}
                            >
                                {isGeneratingReport ? 'GERANDO RELATÓRIO...' : 'EXTRAIR RELATÓRIO MENSAL'}
                            </Button>
                        </Box>
                    </Box>

                </Box>
            )}
        </div>
    );
}